<template>
  <b-modal id="mainoeuvreModal" ref="mainoeuvreModal" scrollable @hide="close">
    <template #modal-header>
      <h5>{{ $t("NEW") }} {{ $t("MAIN_OEUVRE") }}</h5>
      <b-button size="sm" @click="resetModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.028"
          height="17.028"
          viewBox="0 0 17.028 17.028"
        >
          <path
            id="Icon_material-close"
            data-name="Icon material-close"
            d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
            transform="translate(-7.5 -7.5)"
            fill="#393939"
          />
        </svg>
      </b-button>
    </template>

    <form @submit.prevent="addPRO">
      <div class="center">
        <b-form-group :label="$t('WORDING') + '*'" label-for="name">
          <b-form-input
            id="lib"
            v-model="v$.newPRO.lib.$model"
            :state="validateState('lib')"
            oninput="this.value = this.value.toUpperCase()"
            aria-describedby="lib-feedback"
            required
          ></b-form-input>
          <error-handle
            :list="v$.newPRO.lib.$errors"
            id="lib-feedback"
          ></error-handle>
          <div v-if="erreurlist.lib" class="error-message">
            <ul v-if="Array.isArray(erreurlist.lib)">
              <span v-for="(e, index) in erreurlist.lib" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.lib }}</span>
          </div>
        </b-form-group>

        <b-form-group :label="$t('REFERENCE')" label-for="reference ">
          <b-form-input
            id="reference"
            oninput="this.value = this.value.toUpperCase()"
            v-model="v$.newPRO.ref.$model"
            :state="validateState('ref')"
            aria-describedby="ref-feedback"
          ></b-form-input>
          <error-handle
            :list="v$.newPRO.ref.$errors"
            id="ref-feedback"
          ></error-handle>
          <div v-if="erreurlist.ref" class="error-message">
            <ul v-if="Array.isArray(erreurlist.ref)">
              <span v-for="(e, index) in erreurlist.ref" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.ref }}</span>
          </div>
        </b-form-group>
        <b-form-group :label="$t('VAT') + '*'" label-for="tva">
          <b-form-select
            v-model="v$.newPRO.tva.$model"
            :options="optionsTVA"
            :state="validateState('tva')"
            aria-describedby="tva-feedback"
          ></b-form-select>
          <error-handle
            :list="v$.newPRO.tva.$errors"
            id="tva-feedback"
          ></error-handle>
          <div v-if="erreurlist.tva" class="error-message">
            <ul v-if="Array.isArray(erreurlist.tva)">
              <span v-for="(e, index) in erreurlist.tva" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.tva }}</span>
          </div>
        </b-form-group>
        <div class="modalmainoeuvre">
          <b-col md="4">
            <b-form-group :label="$t('TYPE_UNITE') + '*'">
              <b-form-select
                v-model="v$.newPRO.type_unite.$model"
                :options="optionstype"
                :state="validateState('type_unite')"
                aria-describedby="type_unite-feedback"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group style="margin-bottom: 0" :label="$t('Quantité')">
              <b-form-input
                v-model="v$.newPRO.quantite.$model"
                Type="number"
                step="1"
                min="1"
                :state="validateState('quantite')"
                aria-describedby="quantite-feedback"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group :label="$t('UNIT_PRICE') + '*'" label-for="nameunité">
              <b-form-input
                id="nameunité"
                v-model="v$.newPRO.unit_price.$model"
                Type="number"
                min="1"
                max="100000"
                step="1"
                :state="validateState('unit_price')"
                aria-describedby="unit_price-feedback"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </div>
        <!-- ----------------affichage-erreur----------------------------- -->
        <div v-if="erreurlist.type_unite" class="error-message">
          <ul v-if="Array.isArray(erreurlist.type_unite)">
            <span v-for="(e, index) in erreurlist.type_unite" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.type_unite }}</span>
        </div>
        <div v-if="erreurlist.quantite" class="error-message">
          <ul v-if="Array.isArray(erreurlist.quantite)">
            <span v-for="(e, index) in erreurlist.quantite" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.quantite }}</span>
        </div>
        <div v-if="erreurlist.unit_price" class="error-message">
          <ul v-if="Array.isArray(erreurlist.unit_price)">
            <span v-for="(e, index) in erreurlist.unit_price" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.unit_price }}</span>
        </div>
        <!-- ----------------affichage-erreur----------------------------- -->
        <div
          v-if="v$.newPRO.type_unite.$error || v$.newPRO.unit_price.$error"
          class="error-message"
        >
          {{ $t("REQUIRED_FIELD") }}
        </div>

        <b-form-group :label="$t('DESC')" label-for="Description">
          <b-form-textarea
    id="desc"
    v-model="cleanedDesc"
    placeholder="Description..."
    rows="30000"
    max-rows="600000000000"
  ></b-form-textarea>
          <!-- <b-form-textarea
            id="desc"
            v-model="newPRO.desc"
            placeholder="Description..."
            rows="3"
            max-rows="6"
          ></b-form-textarea> -->
          <div v-if="erreurlist.desc" class="error-message">
            <ul v-if="Array.isArray(erreurlist.desc)">
              <span v-for="(e, index) in erreurlist.desc" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.desc }}</span>
          </div>
        </b-form-group>
        <!-- <b-form-checkbox
          id="favoris"
          v-model="newPRO.favoris"
          name="favoris"
          value="true"
          unchecked-value="false"
        >
          {{ $t("FAVORITE") }}
        </b-form-checkbox> -->
      </div>
    </form>
    <template #modal-footer>
      <b-alert variant="warning" show v-if="errorS">
        {{ errorS }}
      </b-alert>
      <div class="double">
        <b-button variant="danger" @click="resetModal()">
          <div class="block-spinner">
            {{ $t("CANCEL") }}
          </div>
        </b-button>
        <b-button
          variant="success"
          @click="addPRO"
          v-if="!getmainoeuvreLoading"
        >
          <div class="block-spinner">
            {{ $t("SAVE") }}
          </div>
        </b-button>
        <b-button variant="success" @click="addPRO" v-else disabled>
          <div class="block-spinner">
            {{ $t("SAVE") }}
            <div v-if="getmainoeuvreLoading" class="loading ml-2">
              <div class="spinner-border" role="status"></div>
            </div>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import {
  required,
  maxLength,
  integer,
  numeric,
  minValue,
  maxValue,
} from "@vuelidate/validators";
import errorHandle from "../ui/errorHandle.vue";

export default {
  components: { errorHandle },
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  data() {
    return {
      newPRO: {
        lib: null,
        ref: null,
        type_unite: "m2",
        quantite: 1,
        unit_price: 1,
        tva: 0,
        desc: null,
        favoris: null,
      },
      erreurlist: {
        lib: null,
        ref: null,
        type_unite: null,
        quantite: null,
        unit_price: null,
        tva: null,
        desc: null,
      },
      optionsTVA: [
        { value: 0, text: "0%" },
        { value: 5.5, text: "5.5%" },
        { value: 10, text: "10%" },
        { value: 20, text: "20%" },
      ],
      optionstype: [
        { value: "m2", text: "m2" },
        { value: "ml", text: "ML" },
        { value: "h", text: "h" },
        { value: "forfait", text: this.$t("TypePrestation.Forfait") },
        { value: "unitaire", text: this.$t("unit_unitaire") },
      ],
      errorS: null,
      box: "",
    };
  },
  validations() {
    return {
      newPRO: {
        lib: { required, maxLength: maxLength(100) },
        ref: { maxLength: maxLength(100) },
        quantite: {
          required,
          integer,
          minValue: minValue(1),
          maxValue: maxValue(1000),
        },
        type_unite: { required },
        unit_price: {
          required,
          numeric,
          minValue: minValue(1),
          maxValue: maxValue(100000),
        },
        tva: { required, numeric },
      },
    };
  },
  methods: {
    ...mapActions(["store_mainoeuvre", "all_entreprises",'all_mainoeuvres']),
    stripHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  },
    validateState(name) {
      const { $dirty, $error } = this.v$.newPRO[name];
      return $dirty ? !$error : null;
    },

    async addPRO() {
      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) return;
      this.errorS = null;
      this.erreurlist = {
        lib: null,
        ref: null,
        type_unite: null,
        quantite: null,
        unit_price: null,
        tva: null,
        desc: null,
      };

      await this.store_mainoeuvre(this.newPRO)
        .then(() => {
          this.resetModal();
          this.all_mainoeuvres({ page: this.page, perPage: 100000 });
          this.$emit("updateList");
        })
        .catch((err) => {
          if (this.isObject(err)) {
            for (const [key, value] of Object.entries(err)) {
              if (!this.erreurlist[key]) {
                this.erreurlist[key] = value;
              }
            }
          } else {
            this.errorS = err;
          }
        });
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },
    resetModal() {
      this.errorS = null;
      this.$refs["mainoeuvreModal"].hide();
      this.erreurlist = {
        lib: null,
        ref: null,
        type_unite: null,
        quantite: null,
        unit_price: null,
        tva: null,
        desc: null,
      };
      this.newPRO = {
        lib: null,
        ref: null,
        type_unite: "m2",
        quantite: 1,
        unit_price: 0,
        tva: 0,
        desc: null,
        favoris: null,
      };
      this.$nextTick(() => {
        this.v$.$reset();
      });
    },

    close(bv) {
      if (this.$refs["mainoeuvreModal"].isShow) {
        if (bv.trigger == "backdrop") {
          bv.preventDefault();
          this.showMsgBox();
        }
      }
    },

    showMsgBox() {
      this.box = "";
      this.$bvModal
        .msgBoxConfirm(`${this.$t("CLOSE")}`, {
          title: `${this.$t("CONFIRM")}`,
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          okTitle: `${this.$t("YES")}`,
          cancelTitle: `${this.$t("NO")}`,
          footerClass: "p-2",
          hideHeaderClose: false,
        })
        .then((value) => {
          if (value) {
            this.resetModal();
          }
        });
    },
  },
  computed: {
    ...mapGetters([
      "getAllentreprises",
      "getmainoeuvreLoading",
      "getOnlineUser",
    ]),
    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    cleanedDesc: {
    get() {
      return this.stripHtml(this.newPRO.desc); // Nettoie le HTML
    },
    set(value) {
      this.newPRO.desc = value; // Met à jour newPRO.desc avec le texte pur
    }
  },
    computedAllentreprises() {
      var list = [
        {
          lib: "TOUTES LES ENTREPRISES",
          id: 1,
        },
      ];
      if (this.getAllentreprises)
        this.getAllentreprises.forEach((element) => {
          if (element.id != 1) list.push(element);
        });
      return list;
    },
  },
  mounted() {
    if (this.isSuperAdmin || this.isCommercialBatigo) {
      if (!this.getAllentreprises) {
        this.all_entreprises({ page: 1, per_page: 1000, with_default: 1 });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.modalmainoeuvre {
  display: flex;
  align-items: center;
  width: 100%;
  .nbunite {
    white-space: nowrap;
  }
}
</style>
